import { useEffect, useState } from 'react';

export function useDeviceInfo() {
  const [deviceInfo, setDeviceInfo] = useState<{ isMobile: boolean; orientation: 'portrait' | 'landscape' }>({
    isMobile: false,
    orientation: 'portrait'
  });

  useEffect(() => {
    const checkDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor;
      const isMobile = /android|avantgo|blackberry|iphone|ipod|ipad|iemobile|opera mini|mobile/i.test(userAgent);
      const isSmallScreen = window.innerWidth <= 1024;
      const finalIsMobile = isMobile || isSmallScreen;

      const orientation = window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';

      setDeviceInfo({
        isMobile: finalIsMobile,
        orientation
      });
    };

    checkDevice();

    window.addEventListener('resize', checkDevice);
    window.addEventListener('orientationchange', checkDevice);

    return () => {
      window.removeEventListener('resize', checkDevice);
      window.removeEventListener('orientationchange', checkDevice);
    };
  }, []);

  return deviceInfo;
}
